import classNames from 'helpers/class-names'
import { FC, ReactNode } from 'react'

interface Props {
  children: ReactNode
  className?: string
  classNameInner?: string
}

export const Panel: FC<Props> = ({
  children,
  className = '',
  classNameInner = '',
}) => (
  <div
    className={classNames(
      'flex rounded-xl bg-gray-100 p-3 dark:bg-gray-800',
      className,
    )}>
    <div
      className={classNames(
        'flex w-full flex-1 flex-row rounded-lg border border-gray-200 bg-white text-left sm:flex-col dark:border-gray-500 dark:bg-gray-600',
        classNameInner,
      )}>
      {children}
    </div>
  </div>
)
